/* Upsell Accessori — intercetta add to cart */
document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('fxUpsellModal');
  var list = document.getElementById('fxUpsellList');
  var titleEl = document.getElementById('fxUpsellTitle');
  if (!modal) return;

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  document.getElementById('fxUpsellClose').addEventListener('click', closeModal);
  document.getElementById('fxUpsellContinue').addEventListener('click', closeModal);
  modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });

  var accessoryMap = {
    'wc-terra': ['Kit Fissaggio Ghost', 'Curva Scarico', 'OLI Cassetta Incasso WC a Terra', 'Raccordo Eccentrico', 'Tubo Collegamento', 'OLI Placca Scarico', 'Placca Scarico Ceramica', 'OLI Kit Fissaggio'],
    'wc-sospeso': ['Kit Fissaggio WC/Bidet Sospesi', 'OLI Cassetta Incasso WC Sospeso', 'Protezione Acustica', 'Tubo Collegamento', 'OLI Placca Scarico', 'Placca Scarico Ceramica'],
    'bidet-terra': ['Kit Fissaggio Ghost', 'Sifone Bidet', 'Piletta Skip-Up', 'Ghiera Troppopieno Ceramica'],
    'bidet-sospeso': ['Kit Fissaggio WC/Bidet Sospesi', 'Sifone Bidet', 'Piletta Skip-Up', 'Ghiera Troppopieno Ceramica', 'Protezione Acustica', 'Staffe UNI', 'Staffa Fissaggio Bidet'],
    'coprivaso': [],
    'cassetta': ['OLI Placca Scarico', 'Placca Scarico Ceramica', 'OLI Kit Fissaggio'],
    'placca': ['OLI Cassetta Incasso', 'OLI Kit Fissaggio'],
    'lavabo': ['Sifone', 'Piletta Skip-Up', 'Ghiera Troppopieno', 'Fissaggio Lavabo'],
    'default': ['Kit Fissaggio Ghost', 'Sifone', 'Piletta Skip-Up']
  };

  function getProductCategory(title) {
    var t = title.toLowerCase();
    if (t.indexOf('cassetta') > -1 && t.indexOf('placca') === -1) return 'cassetta';
    if (t.indexOf('placca') > -1) return 'placca';
    if (t.indexOf('wc') > -1 && t.indexOf('sospeso') > -1) return 'wc-sospeso';
    if (t.indexOf('wc') > -1) return 'wc-terra';
    if (t.indexOf('bidet') > -1 && t.indexOf('sospeso') > -1) return 'bidet-sospeso';
    if (t.indexOf('bidet') > -1) return 'bidet-terra';
    if (t.indexOf('coprivaso') > -1) return 'coprivaso';
    if (t.indexOf('lavabo') > -1) return 'lavabo';
    return 'default';
  }

  function showUpsell(productTitle) {
    var cat = getProductCategory(productTitle);
    var keywords = accessoryMap[cat] || accessoryMap['default'];
    if (keywords.length === 0) { window.location.href = '/cart'; return; }

    titleEl.textContent = productTitle + ' aggiunto!';
    list.innerHTML = '<div style="text-align:center;padding:1rem;color:#999;font-size:0.8rem">Caricamento accessori...</div>';
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    fetch('/collections/accessori-arcadia/products.json?limit=50')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products) return;
        var accessories = data.products.filter(function(p) {
          if (p.product_type !== 'Accessori') return false;
          var pTitle = p.title.toLowerCase();
          return keywords.some(function(kw) { return pTitle.indexOf(kw.toLowerCase()) > -1; });
        });
        if (accessories.length === 0) {
          list.innerHTML = '<div style="text-align:center;padding:0.5rem;color:#999;font-size:0.8rem">Nessun accessorio disponibile</div>';
          return;
        }
        list.innerHTML = '';
        accessories.forEach(function(acc) {
          var pr = acc.variants[0].price;
          var price = typeof pr === 'string' ? pr.replace('.', ',') : (pr / 100).toFixed(2).replace('.', ',');
          var vid = acc.variants[0].id;
          var row = document.createElement('div');
          row.style.cssText = 'display:flex;align-items:center;gap:10px;padding:10px;border:1px solid #D9D2C5;border-radius:10px;transition:all 0.2s';
          var info = document.createElement('div');
          info.style.cssText = 'flex:1;min-width:0';
          info.innerHTML = '<div style="font-size:0.78rem;font-weight:600;color:#1a1a2e;line-height:1.3">' + acc.title + '</div><div style="font-size:0.82rem;color:#2D5A3D;font-weight:700;margin-top:2px">&euro;' + price + '</div>';
          var btn = document.createElement('button');
          btn.style.cssText = 'flex-shrink:0;padding:6px 14px;background:#2D5A3D;color:#fff;border:none;border-radius:6px;font-size:0.75rem;font-weight:700;cursor:pointer;font-family:var(--fx-font);transition:all 0.2s';
          btn.textContent = 'AGGIUNGI';
          btn.addEventListener('click', function() {
            btn.textContent = '...';
            btn.disabled = true;
            fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: vid, quantity: 1}) })
              .then(function() { btn.textContent = 'AGGIUNTO'; btn.style.background = '#2ecc71'; row.style.borderColor = '#2ecc71'; row.style.background = '#f0fdf4'; document.dispatchEvent(new CustomEvent('cart:updated')); })
              .catch(function() { btn.textContent = 'ERRORE'; btn.style.background = '#e74c3c'; });
          });
          row.appendChild(info);
          row.appendChild(btn);
          list.appendChild(row);
        });
      })
      .catch(function() { list.innerHTML = '<div style="text-align:center;padding:0.5rem;color:#999;font-size:0.8rem">Errore caricamento</div>'; });
  }

  /* Intercetta il submit del form add to cart */
  var form = document.getElementById('fxAddToCartForm');
  if (form) {
    var newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);
    newForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = newForm.querySelector('#fxVariantId').value;
      var qty = newForm.querySelector('#fxQtyHidden').value || 1;
      var btn = newForm.querySelector('#fxAddToCart');
      var tEl = btn.querySelector('.fx-config-btn-title');
      var orig = tEl.textContent;
      tEl.textContent = 'AGGIUNTA IN CORSO...';
      btn.style.pointerEvents = 'none';
      fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(window._fxSecondVariantId ? {items:[{id: parseInt(variantId), quantity: parseInt(qty)}, {id: parseInt(window._fxSecondVariantId), quantity: parseInt(qty)}]} : {id: parseInt(variantId), quantity: parseInt(qty)}) /* KH 07/08: include 2a variante bundle (era persa) */ })
        .then(function(r) { return r.json(); })
        .then(function() {
          tEl.textContent = orig;
          btn.style.pointerEvents = '';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          showUpsell(window.productData ? window.productData.title : '');
        })
        .catch(function() {
          tEl.textContent = 'ERRORE';
          btn.style.background = '#e74c3c';
          setTimeout(function() { tEl.textContent = orig; btn.style.background = ''; btn.style.pointerEvents = ''; }, 2000);
        });
    });
  }
});
